module.exports = __webpack_public_path__ + "static/media/profile.203b9a82.jpg";